import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { SavedToSessionstorage } from '@app/shared/constants';
import { exportSecMin, TimeSplited } from '@app/shared/utils';
import { Select, Store } from '@ngxs/store';
import {
  OpenSpecificPanel,
  PANELS_KEYS,
  PanelsState,
  TryActionUnlessPanelIsBlocking,
} from '@radioking/shared/pannel-manager';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Program } from '../../models/programs.model';
import { ProgramsState } from '../../states/programs.state';

@Component({
  selector: 'rk-programs-header',
  templateUrl: './programs-header.component.html',
  styleUrls: ['./programs-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramsHeaderComponent implements OnInit {
  @Select(ProgramsState.programs)
  programs$: Observable<Program[]>;

  estimatedDuration$: Observable<number>;

  @Output()
  readonly changeSearch = new EventEmitter();

  private _memorizedSearch: string | null = null;

  get memorizedSearch(): string {
    if (this._memorizedSearch !== null) {
      return this._memorizedSearch;
    }

    this._memorizedSearch = '';
    const search = sessionStorage.getItem(
      SavedToSessionstorage.MEMORIZED_SEARCH_PROGRAMS,
    );

    if (typeof search === 'string') {
      this._memorizedSearch = JSON.parse(search) as string;
    }

    return this._memorizedSearch;
  }

  set memorizedSearch(search: string) {
    this._memorizedSearch = search;
    sessionStorage.setItem(
      SavedToSessionstorage.MEMORIZED_SEARCH_PROGRAMS,
      JSON.stringify(search),
    );
  }

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    if (this.memorizedSearch) {
      this.editSearch(this.memorizedSearch);
    }

    this.estimatedDuration$ = this.programs$.pipe(
      map(programs => programs.reduce((sum, p) => sum + p.estimatedDuration, 0)),
    );
  }

  editSearch(e: string) {
    if (typeof e === 'string') {
      this.changeSearch.emit(e);
      this.memorizedSearch = e;
    }
  }

  createProgram() {
    const panelsOpened = this.store.selectSnapshot(PanelsState.currentPanel);
    if (panelsOpened === PANELS_KEYS.CREATE_PROGRAM) {
      return;
    }

    this.store.dispatch(
      new TryActionUnlessPanelIsBlocking(
        new OpenSpecificPanel(PANELS_KEYS.CREATE_PROGRAM),
      ),
    );
  }

  getMinutesAndHours(value: number): TimeSplited {
    return exportSecMin(value);
  }
}
